"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetCompareVehicles = exports.addVehiclesToCompare = exports.DELETE_COMPARE_VEHICLES = exports.ADD_VEHICLES_TO_COMPARE = exports.COMPARED_VEHICLES = void 0;
exports.COMPARED_VEHICLES = '[compared Vehicles]';
exports.ADD_VEHICLES_TO_COMPARE = `${exports.COMPARED_VEHICLES} ADD`;
exports.DELETE_COMPARE_VEHICLES = `${exports.COMPARED_VEHICLES} DELETE`;
const addVehiclesToCompare = ({ vehicles }) => ({
    type: exports.ADD_VEHICLES_TO_COMPARE,
    payload: vehicles,
    meta: { feature: exports.COMPARED_VEHICLES },
});
exports.addVehiclesToCompare = addVehiclesToCompare;
const resetCompareVehicles = () => ({
    type: exports.DELETE_COMPARE_VEHICLES,
    payload: [],
    meta: { feature: exports.COMPARED_VEHICLES },
});
exports.resetCompareVehicles = resetCompareVehicles;
//# sourceMappingURL=comparedVehicles.js.map